var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header",attrs:{"id":"app"}},[_c('Header'),_c('main',{staticClass:"mdl-layout__content"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }